import { useState, useEffect } from 'react';

/**
 * Hook to get the current seeker ID for ghost profile creation
 * Generates and persists a seeker ID before auth/profile creation
 */
export function useSeekerAuth() {
  const [seekerId, setSeekerID] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // For ghost profile creation, generate and persist a seeker ID
    const getOrCreateSeekerID = () => {
      // Try to get existing seeker ID from localStorage
      const existingSeekerID = localStorage.getItem('ghost_seeker_id');
      
      if (existingSeekerID) {
        setSeekerID(existingSeekerID);
      } else {
        // Generate new seeker ID for ghost profile
        const newSeekerID = crypto.randomUUID();
        localStorage.setItem('ghost_seeker_id', newSeekerID);
        setSeekerID(newSeekerID);
      }
      
      setIsLoading(false);
    };

    getOrCreateSeekerID();
  }, []);

  const clearGhostProfile = () => {
    localStorage.removeItem('ghost_seeker_id');
    localStorage.removeItem('seeker_onboarding_session');
  };

  return { seekerId, isLoading, clearGhostProfile };
}

/**
 * Hook to manage onboarding session
 */
export function useOnboardingSession() {
  const [sessionId] = useState(() => {
    // Get existing session ID from localStorage or create new one
    const existing = localStorage.getItem('seeker_onboarding_session');
    if (existing) return existing;
    
    const newSessionId = crypto.randomUUID();
    localStorage.setItem('seeker_onboarding_session', newSessionId);
    return newSessionId;
  });

  const clearSession = () => {
    localStorage.removeItem('seeker_onboarding_session');
  };

  return { sessionId, clearSession };
}